<mat-card-title>
  <div style="display: flex; flex-direction: column; width: 100%">
    <div style="display: flex; justify-content: space-between">
      <data-area [settings]="familiesInfo" style="min-width: 250px"></data-area>
      <div *ngIf="this.families.currentRow">
        <mat-menu #appMenu77>
          <button
            mat-menu-item
            (click)="newDelivery()"
            *ngIf="!this.families.currentRow.isNew()"
          >
            {{ settings.lang.newDelivery }}
          </button>
          <button mat-menu-item (click)="preview()">
            {{ settings.lang.displayFamilyAsVolunteerWillSeeIt }}
          </button>
          <button
            mat-menu-item
            (click)="
              families.currentRow.showDeliveryHistoryDialog({
                ui: dialog,
                settings: settings
              })
            "
            *ngIf="!this.families.currentRow.isNew()"
          >
            {{ settings.lang.deliveries }}
          </button>
          <button
            mat-menu-item
            (click)="updateInfo()"
            *ngIf="!this.families.currentRow.isNew()"
          >
            {{ settings.lang.infoAboutUpdates }}
          </button>
          <button
            mat-menu-item
            (click)="sendSmsToCourier()"
            *ngIf="args.familyDelivery && args.familyDelivery.courier"
          >
            {{ settings.lang.sendMessageToVolunteer }}
          </button>
          <button
            mat-menu-item
            *ngIf="canSendWhatsApp()"
            (click)="sendWhatsApp()"
          >
            <mat-icon>textsms</mat-icon>
            <div style="display: inline-flex; line-height: 17px">
              {{ settings.lang.sendWhatsAppToFamily }}
            </div>
          </button>
          <a
            mat-menu-item
            href="tel:{{ args.familyDelivery?.courier?.phone?.thePhone }}"
            style="padding-right: 15px"
            *ngIf="args.familyDelivery && args.familyDelivery.courier"
          >
            <button
              mat-menu-item
              *ngIf="args.familyDelivery && args.familyDelivery.courier"
            >
              <mat-icon>phone</mat-icon>
              <div style="display: inline-flex; line-height: 17px">
                {{ settings.lang.dialTo }}
                {{ settings.lang.volunteer }}
                {{ args.familyDelivery.courier.name }} <br />
                {{ args.familyDelivery?.courier?.phone?.thePhone }}
              </div>
            </button>
          </a>
        </mat-menu>
        <button mat-icon-button [matMenuTriggerFor]="appMenu77">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="args.familyDelivery?.courierComments" class="mat-body">
      {{ settings.lang.commentsWritteByVolunteer }}:
      <div class="mat-body-strong">
        {{ args.familyDelivery.courierComments }}
      </div>
    </div>
    <div *ngIf="args.familyDelivery?.callerComment" class="mat-body">
      {{ settings.lang.callerComment }}:
      <div class="mat-body-strong">{{ args.familyDelivery.callerComment }}</div>
    </div>
  </div>
</mat-card-title>

<div mat-dialog-content class="content">
  <div>
    {{ args.message }}
    <div *ngIf="families.currentRow">
      <mat-accordion *ngIf="familiesInfo" [multi]="true">
        <mat-expansion-panel *ngIf="delivery" #deliveryPanel>
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                {{ settings.lang.deliveryInfo }}
              </mat-panel-title>
            </div>
            <div>
              <mat-panel-description>
                {{ delivery.getShortDeliveryDescription() }}
              </mat-panel-description>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <button
              mat-raised-button
              color="primary"
              style="margin-bottom: 5px"
              *ngIf="showNewDelivery()"
              (click)="newDelivery()"
            >
              {{ settings.lang.newDelivery }}
            </button>
            <data-area [settings]="deliverInfo"></data-area>
          </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel (afterExpand)="addressOpen()" #addressPanel>
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                <mat-icon
                  class="badAddressIcon"
                  *ngIf="
                    !families.currentRow.addressOk &&
                    !families.currentRow.isNew()
                  "
                >
                  warning
                </mat-icon>
                {{ settings.lang.address }}
              </mat-panel-title>
            </div>
            <div>
              <mat-panel-description>
                {{ getAddressDescription() }}
              </mat-panel-description>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <app-address-input
              [field]="families.currentRow.$.address"
              #addressInput
            ></app-address-input>

            <a (click)="showOnMap()">{{ settings.lang.showOnGoogleMap }}</a> |
            <a (click)="editOnGoogle()">{{ settings.lang.updateGoogle }}</a>

            <data-area [settings]="familiesAddress"></data-area>
            <div
              class="addressProblem"
              *ngIf="
                !families.currentRow.addressOk && !families.currentRow.isNew()
              "
            >
              <span class="badAddressTitle">{{
                settings.lang.badAddressTitle
              }}</span>
              {{ settings.lang.badAddressHelpStart }}
              ({{
                families.currentRow.addressHelper.getGeocodeInformation.whyProblem()
              }}). {{ settings.lang.badAddressHelpLine1 }}<br />
              {{ settings.lang.badAddressHelpLine2 }}
            </div>
            <app-images [images]="images"></app-images>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                {{ settings.lang.phones }}
              </mat-panel-title>
            </div>
            <div>
              <mat-panel-description>
                {{ families.currentRow.phone1?.thePhone }}
              </mat-panel-description>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <data-area [settings]="phones"></data-area>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                {{ settings.lang.familyAdditionalInfo }}
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <data-area [settings]="extraFamilyInfo"></data-area>
          </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                {{ settings.lang.deliveryDefaults }}
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <data-area [settings]="deliveryDefaults"></data-area>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel
          *ngIf="
            families.currentRow.duplicateFamilies &&
            families.currentRow.duplicateFamilies.length > 0
          "
        >
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title style="color: red">
                {{ settings.lang.familiesWithSimilarInfo }}
                {{ families.currentRow.duplicateFamilies.length }}
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <mat-list role="list">
              <mat-list-item
                role="listitem"
                *ngFor="let f of families.currentRow.duplicateFamilies"
              >
                <button mat-icon-button (click)="showDuplicate(f)">
                  <mat-icon> edit </mat-icon>
                </button>
                <span>
                  <strong> {{ f.name }}</strong> {{ displayDupInfo(f) }}
                </span>
              </mat-list-item>
            </mat-list>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="familyDeliveries">
          <mat-expansion-panel-header>
            <div>
              <mat-panel-title>
                {{ settings.lang.familyDeliveries }}
              </mat-panel-title>
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <data-grid [settings]="familyDeliveries"></data-grid>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<mat-dialog-actions>
  <button
    mat-raised-button
    color="warning"
    (click)="cancel()"
    *ngIf="!args.disableSave"
  >
    {{ settings.lang.cancel }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="confirm()"
    *ngIf="!args.disableSave"
  >
    {{ settings.lang.save }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="cancel()"
    *ngIf="args.disableSave"
  >
    {{ settings.lang.close }}
  </button>
  &nbsp;
  <a
    *ngIf="families.currentRow && families.currentRow.$.address.valueChanged()"
    (click)="families.currentRow.save()"
    target="_blank"
    >{{ settings.lang.checkAddress }}</a
  >
</mat-dialog-actions>
